import { requestJson } from "../api/apiClient";
import { WEATHER_SCHEDULE_INTERVALS } from "./midpointApi";

export { WEATHER_SCHEDULE_INTERVALS as AUTOMOTIVE_SCHEDULE_INTERVALS };

export async function fetchAutomotivePipelineSources() {
  return requestJson("/api/admin/automotive/sources");
}

export async function fetchAutomotiveSourceHealth() {
  return requestJson("/api/admin/automotive/sources/health");
}

export async function fetchAutomotiveCoverageReport(params = {}) {
  const search = new URLSearchParams();
  if (params.format) search.set("format", params.format);
  if (params.section) search.set("section", params.section);
  const query = search.toString();
  return requestJson(`/api/admin/automotive/coverage${query ? `?${query}` : ""}`);
}

export async function fetchAutomotiveSourceDetail(sourceCode) {
  return requestJson(`/api/admin/automotive/sources/${encodeURIComponent(sourceCode)}`);
}

export async function runAutomotivePipelineSource(sourceCode, options = {}) {
  return requestJson(`/api/admin/automotive/sources/${encodeURIComponent(sourceCode)}/run`, {
    method: "POST",
    body: JSON.stringify({
      dryRun: options.dryRun === true,
      useMock: options.useMock,
    }),
  });
}

export async function updateAutomotivePipelineSource(sourceCode, payload) {
  const response = await requestJson(
    `/api/admin/automotive/sources/${encodeURIComponent(sourceCode)}`,
    {
      method: "PATCH",
      body: JSON.stringify(payload),
    }
  );
  return response.source || response;
}

export async function enableAutomotiveSourceSchedule(sourceCode, scheduleIntervalMinutes) {
  return requestJson(
    `/api/admin/automotive/sources/${encodeURIComponent(sourceCode)}/schedule/enable`,
    {
      method: "POST",
      body: JSON.stringify({ scheduleIntervalMinutes }),
    }
  );
}

export async function disableAutomotiveSourceSchedule(sourceCode) {
  return requestJson(
    `/api/admin/automotive/sources/${encodeURIComponent(sourceCode)}/schedule/disable`,
    { method: "POST", body: JSON.stringify({}) }
  );
}

export async function saveAutomotiveSourceOperatorNotes(sourceCode, operatorNotes) {
  return requestJson(
    `/api/admin/automotive/sources/${encodeURIComponent(sourceCode)}/notes`,
    {
      method: "PATCH",
      body: JSON.stringify({ operatorNotes }),
    }
  );
}

export async function fetchAutomotivePipelineRuns(sourceCode, filters = {}) {
  const params = new URLSearchParams();
  if (filters.limit != null) {
    params.set("limit", String(filters.limit));
  }
  const query = params.toString();
  return requestJson(
    `/api/admin/automotive/sources/${encodeURIComponent(sourceCode)}/runs${query ? `?${query}` : ""}`
  );
}

export async function fetchAutomotiveMonitoringAlerts() {
  return requestJson("/api/admin/automotive/monitoring/alerts");
}

export async function evaluateAutomotiveMonitoring() {
  return requestJson("/api/admin/automotive/monitoring/evaluate", {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export async function patchAutomotiveMonitoringAlert(alertId, payload) {
  return requestJson(`/api/admin/automotive/monitoring/alerts/${encodeURIComponent(alertId)}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function schedulePayloadFromInterval(minutes, scheduleEnabled) {
  if (!scheduleEnabled || minutes == null) {
    return {
      scheduleEnabled: false,
      scheduleIntervalMinutes: null,
    };
  }

  return {
    scheduleEnabled: true,
    scheduleIntervalMinutes: minutes,
  };
}

export function intervalMinutesFromSource(source) {
  if (!source?.scheduleEnabled) {
    return null;
  }

  return source.scheduleIntervalMinutes ?? null;
}

export function formatAdminActionError(error) {
  if (!error) return "Unknown error.";
  const blockers = error.blockers || error.body?.blockers;
  if (blockers?.length) {
    return blockers
      .map((item) => (typeof item === "string" ? item : item.message || item.code))
      .join(" ");
  }
  return error.message || error.body?.message || "Action failed.";
}
